import { Box, Divider, Text } from "@chakra-ui/react"
import { Alert, Pressable, Show, Tag } from "components"

export default function Shipment({ data, ...props }){
    return(
    <Pressable isDisabled={!!data?.error} {...props}>
        <Box w="200px" minH="200" p={6} borderWidth={1} borderRadius={8}>
            <img src={data.company.picture} alt="" title="" style={{ height: 25 }} />
            <Text fontWeight="bold" children={data.name} mt={2} />
            <Divider my={2} />
            <Show visible={!data.error}>
                <Text fontSize="sm" color="GrayText" children={`${data.delivery_range?.min} a ${data.delivery_range?.max} dias úteis`} />
                <Divider my={2} />
                <Tag colorScheme="teal" children={`R$ ${data.price}`} />
            </Show>
            <Show visible={!!data.error}>
                <Text fontSize="xs" color="red" children={data.error} />
            </Show>
        </Box>
    </Pressable>
    )
}